/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Mindshare.css';
import cx from 'classnames';
import Time from './../../components/Time';
// import Hotpush from './../../components/Hotpush';
import Article from './../../components/Article';
import history from '../../history';

import Floattip from './../../components/Floattip';
import Floatlogin from './../../components/Floatlogin'
import FloatBottom from './../../components/FloatBottom'
import SearchError from './../../components/SearchError'
import moment from 'moment'
import AddBrand from './../../components/AddBrand'

import FloatMoreBrand from './../../components/FloatMoreBrand'

const list = [
  '心智占有率',
  'DB总值构成图',
  '历史曲线图',
  '品牌三维图',
  '三维曲线图',
  'KOL参与图',
  '口碑舆情图',
  '受众好感图'
]

class Mindshare extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      listIndex: 0,
      value: '',
      items: [
      ],
      item1:[],
      item2:[],
      isLogin:false,
      isShowFloat:false,
      isShowTip:false,
      isShowSea:false,
      time:'',
      timeItems:[],
      active:6,
      isExpiered:false,
      moreBrand:false
    };

    this.itemArr={
      item1:[],
      item2:[]
    }

    // this.colseCard=this.colseCard.bind(this)
    this.getBattle = this.getBattle.bind(this)
    this.changeValue = this.changeValue.bind(this)
    this.close=this.close.bind(this)
    this.closeSea=this.closeSea.bind(this)
    this.getArtTime=this.getArtTime.bind(this)
    this.closeCard=this.closeCard.bind(this)
    this.changeTime=this.changeTime.bind(this)
  }
  
  getQueryString(name) {   
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");   
    var r = window.location.search.substr(1).match(reg);   
    if (r != null) return decodeURI(r[2]); return null;   
  }  
  componentWillMount() {
    
    let arrItem=[]
    if (moment().format('a') == 'pm') {
      for (let i = 7; i > 0; i--) {
        arrItem.push(moment().subtract(i, 'd').format('MM-DD'))
      }
    } else {
      for (let i = 8; i > 1; i--) {
        arrItem.push(moment().subtract(i, 'd').format('MM-DD'))
      }

    }
    this.setState({ timeItems: arrItem })
  }
  changeTime=(index)=>{
    const aa=this.state.timeItems[index]
    this.setState({ active: index })
  }
  

  componentDidMount() {
    

    let seaBrand,comBrand,isBattle

    isBattle=false
    if(localStorage.getItem('isLogin')){
      if(localStorage.getItem('isExpiered')){
        let aa=localStorage.getItem('isExpiered')=='true'?true:false
        this.setState({isExpiered:aa})
      }
    }else{
      localStorage.setItem('isLogin','false')
    }


    if(localStorage.getItem('isLogin')=='true'&&localStorage.getItem('isExpiered')=='false'){
      let myurl =this.getQueryString('name')
      seaBrand='腾讯'
      comBrand=myurl=='demo'?'VIVO':myurl
      if(myurl !=null && myurl.toString().length>1){
        //  localStorage.setItem('comparison',`${this.getQueryString("name")}`)  
        //  localStorage.setItem('isCom','true')
        seaBrand=localStorage.getItem('com1')
        comBrand=localStorage.getItem('com2')

      }
      this.setState({isShowTip:true,isLogin:true})
      // localStorage.setItem('seaName','oppo')
      if(localStorage.getItem('isCom')=='true'){
        this.setState({isShowTip:false})
      }

      
      if(localStorage.getItem('isBattle')=='true'){
        seaBrand=localStorage.getItem('com1')
        comBrand=localStorage.getItem('com2')
        isBattle=true
      }else if(localStorage.getItem('isBattle')=='false'){
        seaBrand=localStorage.getItem('com1')
      }else if(localStorage.getItem('isBattle')=='null'){
        isBattle=true
        seaBrand='腾讯'
        comBrand='阿里巴巴'
      }

      
      
    }else if(localStorage.getItem('isLogin')=='false'||localStorage.getItem('isLogin')=='true'&&localStorage.getItem('isExpiered')=='true'){
      this.setState({isShowFloat:true})
      let myurl =this.getQueryString('name')
      if(myurl==null){

      }else{
        // localStorage.setItem('isCom','true')      
        // localStorage.setItem('isBattle','true')
        isBattle=true
        
      }     
      // localStorage.setItem('seaName','OPPO')
      // localStorage.setItem('comparison','VIVO')
      if(localStorage.getItem('isBattle')=='true'){
        isBattle=true
      }
      seaBrand='腾讯'
      comBrand='阿里巴巴'
      
    }else if(!localStorage.getItem('com1')){
      let myurl =this.getQueryString('name')
      if(myurl==null){

      }else{
        // localStorage.setItem('isCom','true')      
        isBattle=true
        
      }    
      // localStorage.setItem('seaName',`OPPO`)  
      // localStorage.setItem('comparison','VIVO')
      seaBrand='腾讯'
      comBrand='阿里巴巴'
      
    }


    let [item1,item2]=[[],[]]
    
    let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
    
    const url = `/digitalAssets/center/brandDetail?brandName=${encodeURIComponent(seaBrand)}&statisDate=${aa}`;

     const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
     };
 
     fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        // console.log(data,'对比页···········')
        
          if(data.err_code){
  
              if(data.err_code=='need_login'){
                localStorage.setItem('isLogin','false')
                // history.replace('/dashboard?brandName=腾讯')
                window.scroll(window.screenLeft,window.screenTop+1)
                
                // alert('需要登录')
                this.setState({isShowFloat:true})
              }else if(data.err_code=='trial account expired'){
                // history.replace('/dashboard?brandName=腾讯')
                this.setState({isExpiered:true})
                
                // alert('账号已经过期')
              }else if(data.err_code=='deny'){
                // history.replace('/dashboard?brandName=腾讯')
                this.setState({moreBrand:true})
                // alert('最多只能查看5个品牌')
                
              }else if(data.err_code=='account expired'){
                // history.replace('/dashboard?brandName=腾讯')
                this.setState({moreBrand:true})
                
                // alert('正式账号过期，最多五个品牌')
    
              }else if(data.err_code=='404'){
                this.setState({isShowSea:true})
              }else {
                this.setState({error:true})
              }
          }else if(!data.err_code){
            

            
              item1=data
              this.itemArr.item1=data

              if(this.itemArr.item1.length>0&&this.itemArr.item2.length){
                items=this.itemArr.item1.concat(this.itemArr.item2)
                this.setState((prevState)=>({
                  value:'',
                  items:items
                }))
              }else{
                this.setState((prevState)=>({
                  value:'',
                  items:data
                }))
              }
          }
        
     
      })
      .catch(e => console.log("Oops, error", e))

      // console.log(isBattle,'对比对比')
    if(isBattle){
      // console.log('品牌添加aaaaaaaaaaaaaaaaaaaaaaaa')
      let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')
      
      const url = `digitalAssets/center/brandDetail?brandName=${encodeURIComponent(comBrand)}&statisDate=${aa}`;
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
     
 
     fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        // console.log(data,'对比页···········')
        
        if(data.err_code){
          this.setState({error:true})

          if(data.err_code=='need_login'){
            localStorage.setItem('isLogin','false')
            // history.replace('/dashboard?brandName=腾讯')
            window.scroll(window.screenLeft,window.screenTop+1)
            
            // alert('需要登录')
            this.setState({isShowFloat:true})
          }else if(data.err_code=='trial account expired'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({isExpiered:true})
            
            // alert('账号已经过期')
          }else if(data.err_code=='deny'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({moreBrand:true})
            // alert('最多只能查看5个品牌')
            
          }else if(data.err_code=='account expired'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({moreBrand:true})
            
            // alert('正式账号过期，最多五个品牌')

          }else if(data.err_code=='404'){
            this.setState({isShowSea:true})
          }else {
            this.setState({error:true})
          }

        }else{
          item2=data
          this.itemArr.item2=data
          if(this.itemArr.item1.length>0&&this.itemArr.item2.length>0){
            items=this.itemArr.item1.concat(this.itemArr.item2)
          
            this.setState((prevState) => (
              {
                value: '',
                items:items
              }))
          }
        }
      })
      .catch(e => console.log("Oops, error", e))
    }

    // console.log(this.state.items,'itemmmmsssssssss',item1,'11111',item2,'2222222222')
    let items=this.itemArr.item1.concat(this.itemArr.item2)
    this.setState({
      items:items
    })

  }


  // loadPageVar(sVar){
  //   return decodeURI(window.location.search.replace(new RegExp("^(?:.*[&\\?]"+encodeURI(sVar).replace(/[\.\+\*]/g,"\\$&")+"(?:\\=([^g]*))?).*$","i"),"$1"));
  // }


  getBattle(value) {
    // e.preventDefault();

    
    let aa=moment().format('a')=='pm'?moment().subtract(1,'days').format('YYYY-MM-DD'):moment().subtract(2,'days').format('YYYY-MM-DD')

    let hasBrand
    this.state.items.forEach(function(brand){
      hasBrand=hasBrand==undefined||hasBrand==false?brand.name==value:hasBrand
    })

    // if(this.state.items[1].name  value==this.state.items[0].name)
    if(!hasBrand){
      const url = `/digitalAssets/center/brandDetail?brandName=${encodeURIComponent(value)}&statisDate=${aa}`;
      const myInit = {
        method: 'GET',
        credentials: 'include', 
        mode: 'cors',
        cache: 'no-cache' 
      };
     
 
     fetch(url,myInit)
      .then(response => response.json())
      .then(data => {
        // console.log(data,'对比页···········')
        
        if(data.err_code){
          this.setState({error:true})

          if(data.err_code=='need_login'){
            localStorage.setItem('isLogin','false')
            // history.replace('/dashboard?brandName=腾讯')
            // alert('需要登录')
            this.setState({isShowFloat:true})
          }else if(data.err_code=='trial account expired'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({isExpiered:true})
            
            // alert('账号已经过期')
          }else if(data.err_code=='deny'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({moreBrand:true})
            // alert('最多只能查看5个品牌')
            
          }else if(data.err_code=='account expired'){
            // history.replace('/dashboard?brandName=腾讯')
            this.setState({moreBrand:true})
            
            // alert('正式账号过期，最多五个品牌')

          }else if(data.err_code=='404'){
            this.setState({isShowSea:true})
          }else {
            this.setState({error:true})
          }

        }else {
          // this.setState({isShowSea:true})

          this.setState((prevState) => (
            {
              value: '',
              items: prevState.items.concat(data)
            }))
        } 
      })
      .catch(e => console.log("Oops, error", e))

    }else{
      alert('不能对比已有品牌')
    }
    
  }


  changeValue(e) {
    this.setState({
      value: e.target.value
    })
  }


  renderMindTableCom=()=>{
    
    const theadList=[
      [
        '排名',
        'DB总值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '心智占有率',
      ],[
        '品牌名称',
        '排名',
        'DB值',
        '日涨跌幅',
        '传播度',
        '参与度',
        '好感度',
        '心智占有率',
      ]
    ]
  
    const {items}=this.state

    console.log(items)
    
    return(
      <div className={s.industryTable} >
        <table cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              {theadList[1].map((i,index)=>
                <th key={index}>{i}</th>
              )}
            </tr>
          </thead>
          
          <tbody>
              {items&&items.map((i,index)=>
                <tr key={index}>
                  <td>{i.name}</td>
                  <td>{i.areaIndustryRank}</td>
                  <td>{i.db}</td>
                  <td>{i.daily}<span className={s[i.dailyStyle]}></span></td>
                  <td>{i.spread}</td>
                  <td>{i.favorability}</td>
                  <td>{i.participate}</td>
                  <td>{i.mindList&&i.mindList[0].mindNum}</td>
                </tr>
              )}
              
          </tbody>

        </table>
      </div>
    )
  }





  
  
  

  
  close=()=>{
    this.setState({isShowFloat:false,isShowTip:false,isExpiered:false})
  }

  closeCard=(item)=>{
    // console.log(index)
    let aa=this.state.items

    let cc=aa.filter(items=>{
       if(items!=item){
        return items
      }
    })
    

    this.setState({items:cc})
    console.log(cc,this.state.items)

    if(cc.length==1){
      this.props.doNewItem('品牌详情')

    }else{
      this.props.doNewItem('品牌对比')
    }

    //更改左侧导航内容
    // this.props.doNewItem('ss')
    
  }

  closeSea=()=>{
    this.setState({isShowSea:false})
  }
  getArtTime=(ss)=>{
    this.setState({
        time:ss
    })
  }

  render() {

    // console.log(this.props)

   
    // console.log(this.state.items.length >= 3||this.state.isLogin)
    let aa=this.state.timeItems[this.state.active]
    let articleTime=(`${moment(aa,'MM-DD').subtract(6,'days').format('YYYY-MM-DD')},${moment(aa,'MM-DD').format('YYYY-MM-DD')}`)
    
    // let chartsTime=(`${moment(aa,'MM-DD').format('YYYY-MM-DD')}`)
    
    let chartsTime=aa.substring(0,2)>10?(`${moment(aa,'MM-DD').format('2017-MM-DD')}`):(`${moment(aa,'MM-DD').format('2018-MM-DD')}`)
    
    const { listIndex,items,active } = this.state
    return (
      <div>
      
        <Floattip show={this.state.isShowTip}  close={this.close}/> 
      
        <SearchError show={this.state.isShowSea} close={this.closeSea}/>
        <div className={s.root}>
          
          <ul className={s.conHead}>
            {this.state.items.map((item, index) => (
              <li className={s.cardRoot} key={index}>
                <div className={s.card}>

                  <div className={s.cardImg}>
                    <img src={`/digitalAssets/resources/img/LOGO/${item.id}.png`}/>
                  </div>
                  <div className={s.cardTxt}>
                    <div className={s.cardName}>{item.name}</div>
                    <div className={s.cardAdd}>
                      <span className={s.attr}>{item.region}</span>
                      <span className={s.industry}>{item.industry}</span>
                    </div>
                  </div>
                </div>

                {/* <div className={s.lookMind}>
                  <a href="javascript:;" onClick={()=>this.setState({listIndex:0})}>查看品牌心智占有率</a>
                </div> */}
                <div className={index == 0 ? s.none : s.cardClose} 
                  onClick={(index) => {
                    this.closeCard(item)
                    
                    }
                }>×</div>
              </li>
            ))}

            <div>
              {items.length<3
                &&<AddBrand items={items} battle={true} getBattle={this.getBattle}/>
              }
            </div>
          </ul>

          <div className={s.detailTable}>

            <table cellSpacing="0" cellPadding="0" className={s.comTable}>
            </table>
            {/* <span className={s.tabular}><span className={s.red}>*</span> 当该品牌涉及多个行业时，只显示它在不同行业内心智占有率最高的数值，其它数值详见该品牌详情页。</span> */}
          </div>
          {this.renderMindTableCom()}


          <div className={s.time}>
            <ul className={s.timeBall}>
                {this.state.timeItems.map((item, index) => (
                  <li key={index}
                    className={index == this.state.active ? s.timeNow : ''}
                    onClick={() => this.changeTime(index)}
                  ><a href="javascript:;" ><i></i><span>{item}</span></a></li>
                ))}
            <div className={s.timeBarBox} style={{transform:`translateX(calc(100% * ${active}))`}}>
              <div className={s.timeBar} ></div>
            </div>
            </ul>
            {/* <div className={s.timeBar} style={{transform:`${calcSlate}`}}></div> */}
            
          </div>
          <div className={s.chartsBox}>

            <ul className={s.picItem}>
              {list.map((item, index) =>
                <li key={index} className={listIndex == index ? cx(s.picBtn, s.ac) : s.picBtn} onClick={() => { this.setState({ listIndex: index }) }}>{item}</li>
              )}

            </ul>
            <Time isShow={list[listIndex]} items={this.state.items} time={chartsTime} getArtTime={this.getArtTime} value={this.state.value} />
            
          </div>
          
         
          {/* {this.state.items.length==1?
            <Article time={articleTime} items={this.state.items}/>
          :null} */}
          {this.state.isShowFloat&&<Floatlogin isFixed={this.state.isFixed} show={this.state.isShowFloat} close={this.close}/>}
          {this.state.isExpiered&&<FloatBottom show={this.state.isExpiered} close={this.close}/>}
          <FloatMoreBrand show={this.state.moreBrand}   close={()=>this.setState({moreBrand:false})}   />
        </div>
      </div>
      

    );
  }
}

export default withStyles(s)(Mindshare);



// WEBPACK FOOTER //
// src/routes/mindshare/Mindshare.js